<template>
  <div>
    <script-content v-if="script" :script="script"></script-content>
    <div v-else class="pa-4">Loading script…</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ScriptContent from "@/components/cases/case-config/ScriptContent.vue"
import Helpers from '@/helpers.js'

export default {
  name: "script-item",
  components: { ScriptContent },
  computed: {
    ...mapState({
      scriptId: state => state.cbroute.params.script_id,
      caseType: state => state.caseTypes.current,
      caseTypeId: state => state.cbroute.params.case_type_id
    }),
    script() {
      let caseType = this.caseType
      const caseTypeId = parseInt(this.caseTypeId, 10)
      if (!caseType || caseType.id !== caseTypeId) {
        caseType = Helpers.getCaseTypeById(this.$store.state, this.caseTypeId)
      }
      if (!caseType || !caseType.scripts) {
        return undefined
      }
      const scriptId = parseInt(this.scriptId, 10)
      if (isNaN(scriptId)) {
        return undefined
      }
      return caseType.scripts.find(function (script) {
        return script && script.id === scriptId
      })
    }
  },
  methods: {
    returnToConfig() {
      this.$router.push({ name: 'CaseConfig', params: { case_type_id: this.caseTypeId, config_tab: "Scripts" } })
    },
    toggleMax() {
      this.maximised = !this.maximised
    },
    loadSelectedCase() {
      this.$store.dispatch("getCurrentlySelectedCase", { caseId: this.selectedCase.id })
    }
  }
}
</script>
